import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

// Data/hora — envelope único para os três casos do app:
//   - data avulsa:      data-controller="date-picker"
//   - hora avulsa:      data-controller="date-picker" data-date-picker-mode-value="time"
//   - período (de/até): duas instâncias com role "from"/"to" apontando uma para a outra
//                       via um seletor CSS (ver `app/views/entries/_filters.html.erb`).
//
// O input mantém o valor real (Y-m-d ou H:i, o que o Rails já espera) — para data, um
// altInput exibe o formato pt-BR (dd/mm/aaaa) sem mudar o que é submetido no form.
export default class extends Controller {
  static values = {
    mode: { type: String, default: "date" }, // "date" | "time"
    role: { type: String, default: "" },     // "from" | "to" (período)
    pair: { type: String, default: "" }      // seletor CSS do outro input do período
  }

  connect() {
    this.picker = flatpickr(this.element, this.buildOptions())
  }

  disconnect() {
    this.picker?.destroy()
  }

  buildOptions() {
    if (this.modeValue === "time") {
      return {
        locale: Portuguese,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true
      }
    }

    return {
      locale: Portuguese,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d/m/Y",
      allowInput: true,
      onChange: (selectedDates) => this.syncPair(selectedDates[0])
    }
  }

  // Período com dois inputs separados ("de"/"até"): ao escolher uma data, restringe o
  // mínimo/máximo do outro input, sem exigir um único widget de range.
  syncPair(selectedDate) {
    if (!this.pairValue || !selectedDate) return

    const otherInput = document.querySelector(this.pairValue)
    const otherPicker = otherInput?._flatpickr
    if (!otherPicker) return

    if (this.roleValue === "from") otherPicker.set("minDate", selectedDate)
    if (this.roleValue === "to") otherPicker.set("maxDate", selectedDate)
  }
}
